import classNames from 'classnames';
import React from 'react';

import styles from './ContentRow.css';

interface IContentRowProps {
  size?: 'L' | 'M';
}

export const ContentRow = React.forwardRef<HTMLDivElement, React.PropsWithChildren<IContentRowProps>>(
  function ContentRow({ children, size }, ref) {
    return (
      <div
        ref={ref}
        className={classNames(
          styles['container'],
          size === 'L' && styles['container-l'],
          size === 'M' && styles['container-m'],
        )}
      >
        {children}
      </div>
    );
  },
);

ContentRow.displayName = 'ContentRow';
